import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { CheckCircle, Award, Users, MessageSquare, Globe, Heart, Shield, Phone, MapPin, ArrowRight, Menu, X } from 'lucide-react';
import { companyValues } from '../mockData';

const iconMap = { CheckCircle, Award, Users, MessageSquare, Globe, Heart };

const Values = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const scrollToContact = () => {
    window.location.href = '/#contact';
  };

  return (
    <div className="min-h-screen bg-slate-950">
      {/* Premium Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-slate-950/98 via-emerald-950/95 to-slate-950/98 backdrop-blur-xl border-b border-emerald-500/20 shadow-[0_4px_30px_rgba(16,185,129,0.15)]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="flex items-center justify-between h-20 md:h-28">
            <Link to="/" className="flex items-center group -ml-2 md:-ml-4 mt-1 md:mt-2">
              <div className="relative">
                <div className="absolute -inset-2 md:-inset-3 bg-gradient-to-r from-emerald-500/40 via-green-400/30 to-emerald-500/40 rounded-2xl blur-xl opacity-70 group-hover:opacity-100 transition-opacity duration-500"></div>
                <img 
                  src="https://customer-assets-lqy194kg.emergentagent.net/job_90e246be-0711-4e27-8caa-13f1ea345ba5/artifacts/pl6ilas6_TNA%20Logo.png" 
                  alt="True North Alberta" 
                  className="relative h-16 md:h-24 w-auto rounded-xl shadow-[0_8px_32px_rgba(0,0,0,0.4),0_0_60px_rgba(16,185,129,0.3)] border-2 border-emerald-400/30"
                  style={{filter: 'drop-shadow(0 0 20px rgba(16,185,129,0.4))'}}
                />
              </div>
            </Link>
            <nav className="hidden md:flex items-center gap-6">
              <Link to="/services" className="relative text-gray-200 hover:text-emerald-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider group">
                Services
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-emerald-400 to-green-400 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Link to="/gallery" className="relative text-gray-200 hover:text-emerald-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider group">
                Gallery
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-emerald-400 to-green-400 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Link to="/values" className="relative text-emerald-400 font-bold text-sm uppercase tracking-wider">
                Our Values
                <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-emerald-400 to-green-400"></span>
              </Link>
              <Link to="/testimonials" className="relative text-gray-200 hover:text-emerald-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider group">
                Testimonials
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-emerald-400 to-green-400 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Link to="/faq" className="relative text-gray-200 hover:text-emerald-400 transition-all duration-300 font-semibold text-sm uppercase tracking-wider group">
                FAQ
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-emerald-400 to-green-400 group-hover:w-full transition-all duration-300"></span>
              </Link>
              <Button 
                onClick={scrollToContact} 
                className="relative overflow-hidden bg-gradient-to-r from-emerald-600 via-green-500 to-emerald-600 hover:from-emerald-500 hover:via-green-400 hover:to-emerald-500 text-white font-bold px-8 py-3 rounded-full shadow-[0_4px_20px_rgba(16,185,129,0.4)] transition-all duration-300 border border-emerald-400/30"
              >
                Get a Quote
              </Button>
            </nav>
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 text-white hover:text-emerald-400 transition-colors"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
        {mobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-slate-950 border-b border-emerald-500/20 shadow-2xl z-50">
            <nav className="container mx-auto px-6 py-6 flex flex-col gap-1">
              <Link to="/services" onClick={() => setMobileMenuOpen(false)} className="text-gray-200 hover:text-emerald-400 hover:bg-emerald-500/10 transition-all duration-300 font-semibold text-lg py-3 px-4 rounded-lg">Services</Link>
              <Link to="/gallery" onClick={() => setMobileMenuOpen(false)} className="text-gray-200 hover:text-emerald-400 hover:bg-emerald-500/10 transition-all duration-300 font-semibold text-lg py-3 px-4 rounded-lg">Gallery</Link>
              <Link to="/values" onClick={() => setMobileMenuOpen(false)} className="text-emerald-400 font-semibold text-lg py-3 px-4 rounded-lg bg-emerald-500/10">Our Values</Link>
              <Link to="/testimonials" onClick={() => setMobileMenuOpen(false)} className="text-gray-200 hover:text-emerald-400 hover:bg-emerald-500/10 transition-all duration-300 font-semibold text-lg py-3 px-4 rounded-lg">Testimonials</Link>
              <Link to="/faq" onClick={() => setMobileMenuOpen(false)} className="text-gray-200 hover:text-emerald-400 hover:bg-emerald-500/10 transition-all duration-300 font-semibold text-lg py-3 px-4 rounded-lg">FAQ</Link>
              <Button onClick={() => { scrollToContact(); setMobileMenuOpen(false); }} className="mt-4 bg-gradient-to-r from-emerald-600 via-green-500 to-emerald-600 text-white font-bold px-8 py-3 rounded-full shadow-lg">Get a Quote</Button>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section - Unique split design */}
      <section className="relative pt-24 pb-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-emerald-950/20 to-slate-900"></div>
        {/* Decorative shield */}
        <div className="absolute top-40 right-20 opacity-5">
          <Shield className="w-64 h-64 text-emerald-400" />
        </div>
        <div className="absolute bottom-0 left-0 w-1/3 h-full bg-gradient-to-r from-emerald-600/5 to-transparent"></div>
        <div className="absolute top-1/2 right-1/4 w-80 h-80 bg-green-500/5 rounded-full blur-3xl"></div>
        
        <div className="container mx-auto px-4 lg:px-8 relative z-10 pt-20">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full mb-8">
              <Heart className="w-4 h-4 text-emerald-400" />
              <span className="text-emerald-400 text-sm font-semibold uppercase tracking-widest">Who We Are</span>
            </div>
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-white mb-6 leading-tight">
              Our Core <span className="bg-gradient-to-r from-emerald-400 via-green-300 to-emerald-400 bg-clip-text text-transparent">Values</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
              The principles that guide every project and relationship we build.
            </p>
          </div>
        </div>
      </section>

      {/* Values Grid - Hexagonal inspired design */}
      <section className="relative py-24 px-4 lg:px-8 bg-gradient-to-b from-slate-900 to-slate-950">
        <div className="absolute inset-0 opacity-[0.02]" style={{backgroundImage: 'linear-gradient(30deg, #10b981 12%, transparent 12.5%, transparent 87%, #10b981 87.5%, #10b981), linear-gradient(150deg, #10b981 12%, transparent 12.5%, transparent 87%, #10b981 87.5%, #10b981), linear-gradient(30deg, #10b981 12%, transparent 12.5%, transparent 87%, #10b981 87.5%, #10b981), linear-gradient(150deg, #10b981 12%, transparent 12.5%, transparent 87%, #10b981 87.5%, #10b981)', backgroundSize: '80px 140px', backgroundPosition: '0 0, 0 0, 40px 70px, 40px 70px'}}></div>
        
        <div className="container mx-auto relative z-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {companyValues.map((value, index) => {
              const IconComponent = iconMap[value.icon];
              return (
                <Card key={value.id} className="group relative overflow-hidden bg-gradient-to-br from-slate-800/60 to-slate-900/60 backdrop-blur-sm border-2 border-slate-700/50 hover:border-emerald-500/50 rounded-3xl transition-all duration-500 hover:shadow-[0_20px_60px_rgba(16,185,129,0.15)] hover:-translate-y-2">
                  {/* Glow effect on hover */}
                  <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/0 to-green-500/0 group-hover:from-emerald-500/5 group-hover:to-green-500/5 transition-all duration-500 rounded-3xl"></div>
                  
                  <CardHeader className="relative z-10 p-8">
                    {/* Icon with unique styling per card */}
                    <div className="relative mb-6">
                      <div className="absolute -inset-4 bg-emerald-500/10 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                      <div className={`relative w-20 h-20 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-all duration-500 shadow-xl ${
                        index % 3 === 0 ? 'bg-gradient-to-br from-emerald-600 to-green-700' :
                        index % 3 === 1 ? 'bg-gradient-to-br from-green-600 to-emerald-700' :
                        'bg-gradient-to-br from-teal-600 to-emerald-700'
                      }`}>
                        <IconComponent className="w-10 h-10 text-white" />
                      </div>
                    </div>
                    
                    <CardTitle className="text-2xl font-black text-white mb-4 group-hover:text-emerald-400 transition-colors">{value.title}</CardTitle>
                    <CardDescription className="text-gray-400 text-base leading-relaxed">{value.description}</CardDescription>
                    
                    {/* Decorative line */}
                    <div className="mt-6 flex items-center gap-2">
                      <div className="w-12 h-1 bg-gradient-to-r from-emerald-500 to-green-500 rounded-full group-hover:w-20 transition-all duration-500"></div>
                      <div className="w-2 h-2 bg-emerald-500 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    </div>
                  </CardHeader>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Mission Statement */}
      <section className="relative py-24 px-4 lg:px-8 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950 to-emerald-950/30"></div>
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-emerald-500/30 to-transparent"></div>
        
        <div className="container mx-auto relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full mb-8">
              <Shield className="w-4 h-4 text-emerald-400" />
              <span className="text-emerald-400 text-sm font-semibold uppercase tracking-widest">Our Promise</span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-8 leading-tight">
              We're committed to delivering <span className="bg-gradient-to-r from-emerald-400 to-green-400 bg-clip-text text-transparent">exceptional results</span> with integrity
            </h2>
            <p className="text-xl text-gray-400 leading-relaxed mb-10">
              Every project we undertake is guided by our commitment to quality, honesty, and the success of our clients. We treat every property as if it were our own.
            </p>
            <Button 
              onClick={scrollToContact} 
              size="lg" 
              className="bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-500 hover:to-green-500 text-white px-10 py-7 text-xl font-bold rounded-2xl shadow-[0_8px_40px_rgba(16,185,129,0.4)] transition-all duration-300"
            >
              Work With Us
              <ArrowRight className="ml-3 w-6 h-6" />
            </Button>
          </div>
        </div>
      </section>

      {/* Premium Footer */}
      <footer className="relative bg-gradient-to-b from-slate-900 to-black text-gray-300 pt-20 pb-8 px-4 lg:px-8">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-emerald-500/30 to-transparent"></div>
        
        <div className="container mx-auto">
          <div className="grid md:grid-cols-4 gap-12 mb-16">
            <div className="md:col-span-2">
              <div className="flex items-center gap-4 mb-6">
                <img 
                  src="https://customer-assets-lqy194kg.emergentagent.net/job_90e246be-0711-4e27-8caa-13f1ea345ba5/artifacts/pl6ilas6_TNA%20Logo.png" 
                  alt="True North Alberta" 
                  className="h-16 w-auto rounded-xl"
                />
                <div>
                  <span className="text-lg font-black text-white">TRUE NORTH</span>
                  <span className="block text-xs text-emerald-400 tracking-[0.2em]">ALBERTA PROPERTY SERVICES</span>
                </div>
              </div>
              <p className="text-gray-400 leading-relaxed max-w-md">
                Professional landscaping and snow removal services for Alberta properties. Quality work, reliable service, year-round excellence.
              </p>
            </div>
            
            <div>
              <h3 className="font-bold text-white mb-6 text-lg">Quick Links</h3>
              <ul className="space-y-3">
                <li><Link to="/services" className="text-gray-400 hover:text-emerald-400 transition-colors">Services</Link></li>
                <li><Link to="/gallery" className="text-gray-400 hover:text-emerald-400 transition-colors">Gallery</Link></li>
                <li><Link to="/values" className="text-gray-400 hover:text-emerald-400 transition-colors">Our Values</Link></li>
                <li><Link to="/testimonials" className="text-gray-400 hover:text-emerald-400 transition-colors">Testimonials</Link></li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-bold text-white mb-6 text-lg">Contact</h3>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <MapPin className="w-5 h-5 text-emerald-400" />
                  <span className="text-gray-400">Calgary & Surrounding Areas</span>
                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-emerald-400" />
                  <a href="tel:5873252799" className="text-gray-400 hover:text-emerald-400 transition-colors">587-325-2799</a>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-slate-800 pt-8 text-center">
            <p className="text-gray-500 text-sm">&copy; {new Date().getFullYear()} True North Alberta Property Services. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Values;
